import { useState, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { OperatorSelector } from '../components/admin/OperatorSelector';
import { PollingFlowGrid } from '../components/admin/PollingFlowGrid';
import { useOperators } from '../hooks/useAdminQueries';
import './AdminDashboard.css';

export default function AdminDashboard() {
  const [searchParams, setSearchParams] = useSearchParams();
  const operatorIdFromUrl = searchParams.get('operatorId');

  const [selectedOperatorId, setSelectedOperatorId] = useState<string | null>(operatorIdFromUrl);

  // Fetch operators once - OperatorSelector will share this cached data
  const { data: operatorsData } = useOperators();

  // Sync URL params with state (one-way: URL -> state)
  useEffect(() => {
    if (operatorIdFromUrl && operatorIdFromUrl !== selectedOperatorId) {
      setSelectedOperatorId(operatorIdFromUrl);
    }
  }, [operatorIdFromUrl, selectedOperatorId]);

  const handleOperatorChange = (operatorId: string) => {
    setSelectedOperatorId(operatorId);
    setSearchParams({ operatorId });
  };

  // Memoize operator lookup to avoid re-computing on every render
  const selectedOperator = useMemo(() => {
    if (!selectedOperatorId || !operatorsData?.operators) return null;
    return operatorsData.operators.find((op) => op.id === selectedOperatorId) || null;
  }, [selectedOperatorId, operatorsData?.operators]);

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1 className="trustflight-heading">Admin Dashboard</h1>
        <p className="admin-subtitle">
          Manage polling, configurations, and sync operations
        </p>
      </div>

      <div className="admin-content">
        <OperatorSelector
          selectedOperatorId={selectedOperatorId}
          onSelect={handleOperatorChange}
        />

        {selectedOperator && (
          <div className="operator-workspace">
            <PollingFlowGrid
              operatorId={selectedOperator.id}
              operatorName={selectedOperator.name ?? undefined}
            />
          </div>
        )}
      </div>
    </div>
  );
}

